import React from 'react'
import PageHeader from '../../components/Header'
// import UserDetail from "../components/UserDetail"
// import PageSlider from "../components/Slider"
// import WelcomePage from "../components/WelcomePage"
// import Selector from "../components/Selector"
// import FreeTrial from "../components/FreeTrial"
import PageFooter from '../../components/Footer'
import { useTranslation } from 'react-i18next'
import Pricelist from '../../components/Pricelist'

const PrivateLessons = () => {
  const { t } = useTranslation('translation')

  // const dispatch = useDispatch()
  // const { userProfile } = useSelector((state) => state)
  // const debug = JSON.stringify(userProfile, null, 2)

  // const [hasRoles, setHasRoles] = useState(false)
  // const [hasAwards, setHasAwards] = useState(false)
  // const [hasAdultRanks, setHasAdultRanks] = useState(false)

  // useEffect(() => {
  //     if (userProfile.roles) { setHasRoles(true) }
  //     if (userProfile.awards) { setHasAwards(true) }
  //     if (userProfile.adultRanks) { setHasAdultRanks(true) }
  // }, [userProfile])

  return (
    <div>
      <PageHeader />

      <div id="page_header" className="page-subheader site-subheader-cst">
        <div className="bgback" />
        <div className="th-sparkles" />
        <div className="kl-bg-source">
          <div
            className="kl-bg-source__bgimage"
            style={{
              backgroundImage: 'url(images/general-bg-pc.jpg)',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'scroll',
              backgroundPositionX: 'center',
              backgroundPositionY: 'center',
              backgroundSize: 'cover',
            }}
          />
          <div
            className="kl-bg-source__overlay"
            style={{ backgroundColor: 'rgba(53,53,53,0.1)' }}
          />
        </div>

        <div className="ph-content-wrap d-flex">
          <div className="container align-self-center">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="clearfix" />
              </div>
              <div
                className="col-sm-12 col-md-6 col-lg-6"
                style={{ backgroundColor: 'rgba(0,0,0,0.5)', padding: 15 }}
              >
                <div className="subheader-titles">
                  <h1 className="subheader-maintitle">Individuálne tréningy</h1>
                  <h4 className="subheader-subtitle">{t('page.private-class')}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="kl-bottommask kl-bottommask--mask3">

                <svg width="2700px" height="57px" className="svgmask" viewBox="0 0 2700 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <defs>
                    <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-mask3">
                    <feOffset dx={0} dy={3} in="SourceAlpha" result="shadowOffsetInner1" />
                    <feGaussianBlur stdDeviation={2} in="shadowOffsetInner1" result="shadowBlurInner1" />
                    <feComposite in="shadowBlurInner1" in2="SourceAlpha" operator="arithmetic" k2={-1} k3={1} result="shadowInnerInner1" />
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0" in="shadowInnerInner1" type="matrix" result="shadowMatrixInner1" />
                    <feMerge>
                        <feMergeNode in="SourceGraphic" />
                        <feMergeNode in="shadowMatrixInner1" />
                    </feMerge>
                    </filter>
                </defs>
                <path d="M-2,57 L-2,34.007 L1268,34.007 L1284,34.007 C1284,34.007 1291.89,33.258 1298,31.024 C1304.11,28.79 1329,11 1329,11 L1342,2 C1342,2 1345.121,-0.038 1350,-1.64313008e-14 C1355.267,-0.03 1358,2 1358,2 L1371,11 C1371,11 1395.89,28.79 1402,31.024 C1408.11,33.258 1416,34.007 1416,34.007 L1432,34.007 L2702,34.007 L2702,57 L1350,57 L-2,57 Z" className="bmask-bgfill" filter="url(#filter-mask3)" fill="#fbfbfb" />
                </svg>

              <i className="fas fa-angle-down" />
            </div> */}
      </div>

      <section className="hg_section hg_section--relative">
        {/*** <div className="kl-bg-source kl-bgSource-imageParallax js-KyHtmlParallax is-fixed is-visible" style={{height: 625, width: 1231, transform: 'translate3d(0px, 129.898px, 0px)'}}>
                    <div className="kl-bg-source__bgimage" style={{backgroundImage: 'url("images/photo-1431578500526-4d9613015464-resized.jpg")', backgroundRepeat: 'no-repeat', backgroundAttachment: 'scroll', backgroundPosition: '50% 50%', backgroundSize: 'cover', transform: 'translate3d(0px, -100px, 0px)'}} />
                </div>
                 ***/}
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-6">
                  <div className="left-side">
                    {/*
                                        <img src="images/Master-Cycle-Lockup-Logo-COLOR.png" alt="The Gracie Combatives® Program" />
                                        <br /><br /><br />
                                        */}

                    {/* <h3 className="kl-font-alt fs-larger tcolor fw-bold title">                                             */}
                    {/* <span className="fw-thin"> */}
                    {/* <span className="fw-semibold tcolor"></span> */}
                    {/* </span> */}
                    {/* </h3> */}
                    <p>{t('program.pc1')}</p>

                    <p>{t('program.pc2')}</p>

                    <p>{t('program.pc3')}</p>
                    {/***
                                        <ul className="features">
                                            <li><p>BJJ je dizajnovane pre sebeobranu aj proti vacsiemu a silnejsiemu oponentovi.</p></li>
                                            <li><p>Nieje potreba ziadnich predchazajucich skusenosti s bojovim umenim</p></li>
                                        </ul>
                                        <a href="#" target="_blank" className="btn btn-fullcolor btn-third">BUY NOW</a>
                                        ***/}
                  </div>
                </div>

                <div className="col-sm-12 col-md-12 col-lg-6">
                  <div className="fluid-width-video-wrapper" style={{ paddingTop: '75%' }}>
                    <iframe
                      title="pc"
                      src="https://www.youtube.com/embed/oXzbgDe_VVQ?rel=0&controls=0&showinfo=0"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="hg_section pt-10">
        <div className="container">
          <div className="row mb-30">
            <div className="col-sm-12 col-md-12">
              <div className="kl-title-block clearfix  tbk-symbol--icon tbk--colored tbk-icon-pos--after-title pbottom-30">
                <h3 className="tbk__title kl-font-alt fs-larger tcolor fw-bold">
                  {t('program.pc4')}
                </h3>
                {/*
                    <div className="tbk__symbol">
                        <span className="tbk__icon fs-xxl light-tcolor fas fa-ellipsis-h" />
                    </div>
                    */}
                {/*
                    <h4 className="tbk__subtitle fs-m light-tcolor">
                        WE'RE GOOD AT SOME STUFF AND VERY GOOD AT OTHER STUFF
                    </h4>
                    */}
                <p>{t('program.pc5')}</p>
              </div>
            </div>
          </div>

          <div className="row mb-30">
            <div className="col-sm-12 col-md-12">
              <div className="kl-title-block clearfix  tbk-symbol--icon tbk--colored tbk-icon-pos--after-title pbottom-30">
                <h3 className="tbk__title kl-font-alt fs-larger tcolor fw-bold">
                  {t('program.pc6')}
                </h3>
                <p>{t('program.pc7')}</p>
              </div>
            </div>
          </div>

          <div className="row mb-30">
            <div className="col-sm-12 col-md-12">
              <div className="kl-title-block clearfix  tbk-symbol--icon tbk--colored tbk-icon-pos--after-title pbottom-30">
                <h3 className="tbk__title kl-font-alt fs-larger tcolor fw-bold">
                  {t('program.pc8')}
                </h3>
                <p>{t('program.pc9')}</p>

                <p>{t('program.pc10')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Pricelist category={['private-class']} />

      <PageFooter />
    </div>
  )
}

export default PrivateLessons
